
import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { CommonService } from '@/services'
@Component({
    components: {}
})
export default class extends Vue {
    private typeList: any[] = []
    private list: any[] = []
    private form = {
        typeId: '',
        id: ''
    }
    private topTotal = 0
    private loading = false
    private isLoading = true
    private firstInit = true
    private rules = {
        id: [{ required: true, message: '请选择文章', trigger: 'blur' }],
        typeId: [{ required: true, message: '请选择分类', trigger: 'blur' }]
    }
    get formRef() {
        return this.$refs.createTypeRef as ElForm
    }

    async mounted() {
        await this.getTypeList()
        await this.getArticles(true)
        await this.getArticles()
        if (this.firstInit) {
            this.isLoading = false
        }
        this.firstInit = false
    }

    async getTypeList() {
        this.isLoading = true
        const result = await CommonService.getIArticleTypes({})
        if (result.status === 200) {
            this.typeList = result.data
        }
        this.isLoading = false
    }

    async getArticles(isTop = false) {
        const params = { type_id: this.form.typeId ? this.form.typeId : undefined }
        let top = isTop ? 1 : 0
        Object.assign(params, { top })
        this.isLoading = true
        const result = await CommonService.getIArticleList(params)
        if (result.status === 200) {
            this.formatArticles(result.data.list)
            if (isTop) {
                this.topTotal = result.data.page_total
            }
        }
        if (!this.firstInit) {
            this.isLoading = false
        }
    }

    formatArticles(list: any) {
        list.map((n: any) => {
            (n.value = n.id), (n.label = n.title)
        })
        this.list = list
    }

    onTypeChange() {
        this.getArticles()
    }

    onConfirm() {
        this.formRef.validate(async valid => {
            if (valid) {
                if (this.topTotal >= 6) {
                    this.$confirm('当前仅支持添加6篇置顶文章，请先移出', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        const url = '/setting/institute/top/list'
                        return window.open(url)
                    })
                } else {
                    this.topTotal += 1
                }
                this.loading = true
                const params = {
                    type_id: this.form.typeId,
                    id: this.form.id[0],
                    top: 1
                }
                const result = await CommonService.updateIArticle(params)
                if (result.status === 200) {
                    this.$msuccess('添加成功!')
                    this.getArticles()
                }
                this.loading = false
            }
        })
    }

    onReset() {
        this.formRef.resetFields()
    }
}
